<template>
  <main
    class="main customer_guarantee_confirm"
    role="main"
    ref="main"
    v-if="isCompleted"
  >
    <div class="gc_wrap">
      <section class="gc_sec_1">
        <div class="gc_top">
          <div class="top_txt">
            <h1 v-html="contents.topText1"></h1>
            <h3 v-html="contents.topText2"></h3>
          </div>
          <div class="top_img">
            <img
              :src="require(`@/assets/front/images/v2/${contents.topImage}`)"
            />
          </div>
        </div>
        <div
          class="gc_con"
          ref=""
          v-if="confirmType == 'CONFIRM' || confirmType == 'REPORT'"
        >
          <div class="con_li">
            <div class="li_title">거래매장</div>
            <div class="li_con">{{ applyContents.storeName }}</div>
          </div>
          <div class="con_li">
            <div class="li_title">상품구성</div>
            <div class="li_con">{{ applyContents.item }}</div>
          </div>
          <div class="con_li">
            <div class="li_title">설치지역</div>
            <div class="li_con">{{ getArea(applyContents.area) }}</div>
          </div>
          <div class="con_li">
            <div class="li_title">설치희망일</div>
            <div class="li_con">{{ getDate(applyContents.installDate) }}</div>
          </div>
          <div class="con_li">
            <div class="li_title">약속지원금</div>
            <div class="li_con">{{ applyContents.supportTotal | comma }}원</div>
          </div>
        </div>
        <div class="gc_con" ref="" v-if="confirmType == 'CHANGE'">
          <div class="gc_con_title">변경된 설치일을 알려주세요!</div>
          <div class="gc_con_txt">
            퍼스지급보장을 위해, 변경된 설치일에 알림톡을 보내드립니다!
          </div>
          <div class="gc_select_box_wrap">
            <div class="gc_select_box_title">
              변경된 설치일<span class="aster">*</span>
            </div>
            <div class="gc_select_box">
              <div class="gc_box_datepicker">
                <datepicker
                  placeholder="날짜를 선택해주세요"
                  :highlighted="highlighted"
                  v-model="changeDate"
                  :value="changeDate"
                  :language="ko"
                  :format="datePickerFormat"
                  :open-date="openDate"
                  :disabledDates="disabledDates"
                ></datepicker>
              </div>
              <div class="boxArrow">
                <img
                  :src="require(`@/assets/front/images/mobile/i_select.svg`)"
                  alt=""
                />
              </div>
            </div>
            <p class="valid" :class="{ on: isValid }">
              {{ this.errorMessage }}
            </p>
          </div>
        </div>
      </section>
      <section class="gc_sec_2">
        <div class="gc_btm">
          <div class="gc_btn" @click="setBtnProcess(contents.btmLinkType1)">
            {{ contents.btmText1 }}
          </div>
          <div
            class="gc_txt"
            @click="setBtnProcess(contents.btmLinkType2, 'MOVE')"
          >
            {{ contents.btmText2 }}
          </div>
          <div
            class="gc_txt"
            @click="setBtnProcess(contents.btmLinkType3, 'MOVE')"
          >
            {{ contents.btmText3 }}
          </div>
        </div>
      </section>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: popupTitle,
        type: 'alert',
        msg: popupMsg,
      }"
      @close="popupClose"
    />
  </main>
</template>

<script>
import {
  mapActions as mapInternetMapActions,
  mapGetters as mapInternetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';

import format from 'date-fns/format';
import { ko as dateKo } from 'date-fns/locale';

export default {
  name: 'GuaranteeConfirm',
  components: {
    Datepicker,
    DesignPopup2,
  },
  data() {
    return {
      isValid: false,
      errorMessage: '',
      designPopup: false,
      popupTitle: '',
      popupMsg: '',
      datePickerFormat: 'M월 dd일 (D요일)',
      ko: ko,
      openDate: new Date(),
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      highlighted: {
        dates: [new Date()],
      },
      changeDate: '',
      confirmType: '', // 입금확인 : CONFIRM, 변경하기 : CHANGE, 신고하기 : REPORT
      contentsList: [
        {
          confirmType: 'CONFIRM',
          topText1: '입금된 지원금을<br />확인하셨나요?',
          topText2:
            '지원금이 잘 입금되었는지 확인하셨나요?<br />혹시 문제가 있다면, 퍼스에게 알려주세요!<br />퍼스가 빠르게 도와드립니다.',
          topImage: 'character/img_person_01.png',
          btmText1: '입금 확인',
          btmText2: '설치일을 변경했어요 >',
          btmText3: '아직 못 받았어요 >',
          btmLinkType1: 'CONFIRM',
          btmLinkType2: 'CHANGE',
          btmLinkType3: 'REPORT',
        },
        {
          confirmType: 'CHANGE',
          topText1: '설치일을<br />변경하셨나요?',
          topText2:
            '변경된 날짜를 알려주세요! 해당 날짜 다음날에<br />지원금 확인 알림을 다시 보내드리며,<br />문제가 생기면 퍼스가 빠르게 도와드립니다!',
          topImage: 'character/img_person_02.png',
          btmText1: '변경하기',
          btmText2: '지원금을 받았어요 >',
          btmText3: '아직 못 받았어요 >',
          btmLinkType1: 'CHANGE',
          btmLinkType2: 'CONFIRM',
          btmLinkType3: 'REPORT',
        },
        {
          confirmType: 'REPORT',
          topText1: '지원금을<br />받지 못하셨나요?',
          topText2:
            '퍼스지급보장 매장에서 지원금을 받지 못했다면<br />퍼스가 대신 지급해 드립니다.<br />지원금을 못 받으셨다면, 신고하기를 눌러주세요!',
          topImage: 'character/img_person_03.png',
          btmText1: '신고하기',
          btmText2: '설치일을 변경했어요 >',
          btmText3: '지원금을 받았어요 >',
          btmLinkType1: 'REPORT',
          btmLinkType2: 'CHANGE',
          btmLinkType3: 'CONFIRM',
        },
      ],
      contents: {},
      applyContents: {},
      isCompleted: false,
    };
  },
  async created() {
    console.log('this.$route.namethis.$route.name');
    console.log(this.$route.name);

    // alert(this.$route.query.confirmType);
    this.confirmType = this.$route.query.confirmType;
    this.applyId = this.$route.query.applyId || 0;

    if (
      this.confirmType != 'CONFIRM' &&
      this.confirmType != 'CHANGE' &&
      this.confirmType != 'REPORT'
    ) {
      this.$router.push({ name: 'Home' });
      return;
    }

    if (this.applyId == 0 || !this.applyId) {
      this.$router.push({ name: 'Home' });
      return;
    }
    this.contents = this.contentsList.find(
      list => list.confirmType === this.confirmType,
    );

    await this.getApplySimple();
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  async mounted() {},
  computed: {},
  methods: {
    ...mapInternetMapActions([
      internetTypes.SELECT_INTERNET_SUPPORT_APPLY_LIST,
      internetTypes.SELECT_INTERNET_APPLY_LIST_SIMPLE,
      internetTypes.UPDATE_INTERNET_APPLY_INSTALL_DATE,
      internetTypes.UPDATE_INTERNET_APPLY_DEPOSIT,
    ]),
    getApplySimple() {
      const params = {
        applyId: this.applyId,
      };
      this[internetTypes.SELECT_INTERNET_APPLY_LIST_SIMPLE](params).then(
        res => {
          this.applyContents = res;

          console.log('this.applyContents');
          console.log(this.applyContents);

          this.isCompleted = true;
        },
      );
    },
    setBtnProcess(type, linkType = '') {
      if (linkType == 'MOVE') {
        this.$router.replace({
          name: 'InternetCommerce.GuaranteeConfirm',
          query: { confirmType: type, applyId: this.applyId },
        });
      } else {
        if (type == 'CONFIRM') {
          // 입금 확인 처리 후 alert 발생 후 리뷰 작성하기 페이지 이동
          let params = {
            applyId: this.applyId,
          };

          this[internetTypes.UPDATE_INTERNET_APPLY_DEPOSIT](params).then(
            res => {
              this.popupTitle = '입금 확인이 완료되었습니다.';
              this.popupMsg =
                '<img src="' +
                require('@/assets/front/images/new/img_pop_bak.png') +
                '" style="width:5rem;height:auto;text-align:center;display:inline-block;" /><br />나이스오모바일과의 상담이 만족스러우셨다면<br />리뷰를 작성하여 경험을 공유해 주세요!';
              this.designPopup = true;
            },
          );
        } else if (type == 'CHANGE') {
          // 설치일 변경 후 alert 발생 후 신청현황 페이지 이동
          let params = {
            installDate: '',
            applyId: this.applyId,
          };

          if (this.changeDate) {
            this.isValid = false;
            params.installDate = format(this.changeDate, 'yyyy-MM-dd');
          } else {
            this.errorMessage = '날짜를 선택해주세요';
            this.isValid = true;
            return;
          }

          console.log('params');
          console.log(params);

          this[internetTypes.UPDATE_INTERNET_APPLY_INSTALL_DATE](params).then(
            res => {
              this.popupTitle = '설치일 변경이 완료 되었습니다!';
              this.popupMsg =
                '<img src="' +
                require('@/assets/front/images/new/img_pop_bell.png') +
                '" style="width:5rem;height:auto;text-align:center;display:inline-block;" /><br />지원금 수령을 잊지 않도록,<br />변경된 설치일 다음날에 알림톡을 보내드립니다!';
              this.designPopup = true;
            },
          );
        } else if (type == 'REPORT') {
          // 신고하기 페이지로 이동
          this.goReportStore();
        }
      }
    },
    popupClose() {
      this.designPopup = false;
      if (this.confirmType == 'CONFIRM') {
        this.goReviewStore();
      } else {
        this.goApplyMain();
      }
    },
    goApplyMain() {
      this.$router.replace({
        name: 'Apply.Main',
      });
    },
    goReviewStore() {
      this.$router.replace({
        name: 'Shops.WriteReview',
        params: { id: this.applyContents.storeId },
        query: { type: 'internet' },
      });
    },
    goReportStore() {
      this.$router.push({
        name: 'chat.report',
        query: {
          applyId: this.applyId,
          name: this.applyContents.storeName,
        },
      });
    },
    getArea(address) {
      let strArr = address.split(' ');
      return strArr[0] + ' ' + strArr[1];
    },
    getDate(installDate) {
      const iDate = new Date(installDate);
      return format(iDate, 'yyyy.MM.dd (E)', { locale: dateKo });
    },
  },
};
</script>
